import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Pagination from '../Pagination';

function getData(data, pager) {
  if (!Array.isArray(data)) return data;
  if (data.length <= pager.pageSize) return data;
  var start = (pager.current - 1) * pager.pageSize;
  return data.slice(start, start + pager.pageSize);
}

export default function (Component) {
  return (
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(_class, _PureComponent);

      var _super = _createSuper2(_class);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _super.call(this, props);
        var pp = props.pagination || {};
        _this.state = {
          current: pp.current || pp.defaultCurrent || 1,
          pageSize: pp.pageSize || 10
        };
        _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(_class, [{
        key: "getProp",
        value: function getProp(key) {
          return this.props.pagination[key] || this.state[key];
        }
      }, {
        key: "getPager",
        value: function getPager(data, pagination) {
          var loading = this.props.loading;
          var total = Array.isArray(data) ? data.length : 0;
          return Object.assign({
            current: this.getProp('current'),
            pageSize: this.getProp('pageSize'),
            total: total,
            disabled: !!loading
          }, pagination, {
            onChange: this.handleChange
          });
        }
      }, {
        key: "handleChange",
        value: function handleChange(current, pageSize) {
          var _ref = this.props.pagination,
              onChange = _ref.onChange;
          this.setState({
            current: current,
            pageSize: pageSize
          });
          if (onChange) onChange(current, pageSize);
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              pagination = _this$props.pagination,
              data = _this$props.data,
              props = _objectWithoutProperties(_this$props, ["pagination", "data"]);

          var pager = this.getPager(data, pagination);
          return [
          /*#__PURE__*/
          React.createElement(Component, Object.assign({
            key: "origin",
            data: getData(data, pager)
          }, props)),
          /*#__PURE__*/
          React.createElement(Pagination, Object.assign({
            key: "pager"
          }, pager))];
        }
      }]);

      return _class;
    }(PureComponent)
  );
}